import {flushSync} from 'react-dom';
import {createRoot} from 'react-dom/client';

import zoomPalette from 'zoomPalette';


/**
 * Convert the given svg element to a png with intrinsic size 4x the desired height
 * @param {SVGElement} svgElement
 * @param {function} loadCallback
 * @param {function} errCallback
 */
export function svgToPng(svgElement, loadCallback, errCallback) {
  const targetSize = parseFloat(svgElement.parentElement.style.fontSize) || 16;
  const targetHeight = targetSize;
  const targetWidth = targetSize;
  const color = svgElement.parentElement.style.color;
  svgElement.style.color = color || zoomPalette.gray[60];
  const svgString = new XMLSerializer().serializeToString(svgElement);
  // Draw the svg to a larger img png size than the target size for higher quality
  const img = new Image(targetWidth*4, targetHeight*4);

  // !! Must use data: URLs to load imgs !!
  // CSP img-src * data:; will block blob: urls.
  const dataPrefix = 'data:image/svg+xml;charset=utf-8,';
  const svgUrl = dataPrefix + encodeURIComponent(svgString);

  img.onload = () => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    canvas.width = img.width;
    canvas.height = img.height;

    context.drawImage(img, 0, 0, img.width, img.height);

    const pngDataUrl = canvas.toDataURL('image/png');
    URL.revokeObjectURL(svgUrl); // Clean up memory
    loadCallback(pngDataUrl);
  };
  img.onerror = (e) => {
    errCallback(e);
  };
  img.src = svgUrl;
}

/**
 * Read all svg sources, convert to png, and replace with img elements
 * @param {HTMLElement} rootDomEl
 * @return {Promise}
 */
export async function inlineDomImageStyles(rootDomEl) {
  const svgEls = rootDomEl.querySelectorAll('svg');
  const promises = [];
  for (const el of svgEls) {
    const onLoadPromise = new Promise((resolve, reject) => {
      svgToPng(
        el,
        (pngDataUrl) => {
          const img = document.createElement('img');
          const targetHeight = parseFloat(el.parentElement.style.fontSize) || 16;
          el.parentElement.style.height = `${targetHeight+2}px`;
          // Microsoft Word or older Outlook Client may only recognize the width/height attribute
          // while ignore the CSS properties.
          img.width = 16;
          img.height = 16;
          img.style = 'height: 1em; width: 1em; display: inline; object-fit: contain;';
          img.src = pngDataUrl;
          el.parentElement.replaceChild(img, el);
          resolve(pngDataUrl);
        },
        (e) => {
          reject(e);
        });
    });
    promises.push(onLoadPromise);
  }
  return Promise.allSettled(promises);
}

/**
 *
 * @param {ReactElement} reactEl
 * @return {Promise<string>}
 */
export async function clientRenderToString(reactEl) {
  const div = document.createElement('div');
  const root = createRoot(div);
  flushSync(() => {
    root.render(reactEl);
  });
  await inlineDomImageStyles(div);
  return div.innerHTML;
}

export const EmailFieldSnippet = (props) => {
  return <div
    style={{
      lineHeight: '18px',
      display: 'inline',
      flexDirection: 'row',
      alignItems: 'center',
      height: '18px',
      ...props.style,
    }}
  >
    {props.children}
  </div>;
};

export const emailFieldSnippetIconStyle = {
  display: 'inline',
  flexDirection: 'row',
  alignItems: 'center',
  height: '18px',
  msoLineHeightRule: 'exactly',
  lineHeight: '16px',
  verticalAlign: 'bottom',
};


export const EmailFieldSnippetText = (props) => {
  return <span
    style={{
      color: zoomPalette.gray[60],
      display: 'inline',
      flexDirection: 'row',
      alignItems: 'center',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '18px',
      textDecoration: 'none',
      height: '18px',
      marginRight: '12px',
      marginLeft: '8px',
      Margin: '0 12px 0',
      verticalAlign: 'bottom',
      ...props.style,
    }}
  >
    {props.children}
  </span>;
};

